export const CELL_HEIGHT = 48;
export const MIN_GRID_HEIGHT = 48 * 6;
